module.exports = __webpack_public_path__ + "static/img/s-no.591a5ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/s-no.png
// module id = /R6g
// module chunks = 1